/*
 PC用スライダー one ソースなので、幅に合わせて隠したり、出したり
 */
var mvItemsHover = function() {
    this.$items = $('#js-mainvisualSlide .mainvisual-slide-item');
    this.$mainvisualBG = $('.mainvisual-bg');
    this.mainvisualBgImg = $('.mainvisual-bg-img');
    this.$mainvisualPostUrl = $('.mainvisual-post-url');
    this.$mainvisualPostTitle = $('.mainvisual-post-title');
    this.$mainvisualPostLead = $('.mainvisual-post-lead');
    this.selectedIndex = 0;
    this.beforeSelectedIndex = 0;
};

mvItemsHover.prototype = {
    init: function() {
        var _this = this;
        _this.$items.each(function(i){
            var $this = $(this);
            var $item = $this;
            var $figure = $this.find('figure');
            if (i > 0) {
                var $bg = _this.mainvisualBgImg.clone();
                $bg.css({
                    zIndex: -2,
                    backgroundImage: 'url('+ $figure.data('img') +')',
                    opacity: 0,
                });
                $bg.addClass('js-no-parallax');

                _this.$mainvisualBG.append($bg);

            } else {
                _this.$mainvisualPostUrl.attr('href', $figure.parent('a').attr('href'));
            }

            var $bgImg = $('.mainvisual-bg-img:nth-child(' + (i + 1) + ')');
            if ($item.hasClass('mainvisual-slide-ad')) {
                $bgImg.addClass('js-no-parallax');
                $bgImg.addClass('mainvisual-ad-img');
                $bgImg.append('<div class="mainvisual-ad-label text-ft">ADVERTISING</div>');
            } else {
                $bgImg.removeClass('mainvisual-ad-img');
                $bgImg.find('.mainvisual-ad-label').remove();
            }

            $this.on('mouseenter', function(){
                _this.beforeSelectedIndex = _this.selectedIndex;

                if ($item.hasClass('mainvisual-slide-ad')) {
                    $('#js-globalHeader').addClass('display-ad');
                    $('.mainvisual').addClass('mainvisual-ad');
                    $('.mainvisual-post-url').addClass('mainvisual-ad');
                } else {
                    $('#js-globalHeader').removeClass('display-ad');
                    $('.mainvisual').removeClass('mainvisual-ad');
                    $('.mainvisual-post-url').removeClass('mainvisual-ad');
                }

                TweenMax.to(_this.mainvisualBgImg, 1, {
                    autoAlpha: 0,
                    onStart: function() {
                        _this.selectedIndex = i;
                        _this.mainvisualBgImg.addClass('js-no-parallax');
                        if (_this.$items.eq(i).hasClass('mainvisual-slide-ad')) {
                            _this.$mainvisualPostUrl.addClass('gofollow');
                        } else {
                            _this.$mainvisualPostUrl.removeClass('gofollow');
                            _this.mainvisualBgImg.eq(i).removeClass('js-no-parallax');
                        }
                        _this.mainvisualBgImg.eq(i).trigger('mainVisualChanged');
                        TweenMax.set(_this.mainvisualBgImg, {
                            zIndex: -2,
                            delay: 0.05
                        });
                        TweenMax.set(_this.mainvisualBgImg.eq(_this.beforeSelectedIndex), {
                            zIndex: -1,
                            delay: 0.05
                        });
                        _this.$mainvisualPostUrl.attr('href', $figure.parent('a').attr('href'));
                        _this.$mainvisualPostTitle.removeClass('mainvisual-post-title-animation-init').removeClass('mainvisual-post-title-animation').text($figure.data('text'));
                        _this.$mainvisualPostLead.removeClass('mainvisual-post-lead-animation-init').removeClass('mainvisual-post-lead-animation').text($this.find('.caption-text').text());
                        TweenMax.set(_this.mainvisualBgImg.eq(_this.selectedIndex), {
                            zIndex: 1,
                            delay: 0.05
                        });
                        TweenMax.to(_this.mainvisualBgImg.eq(_this.selectedIndex), 1, {
                            autoAlpha: 1,
                            zIndex: 1,
                            delay: 0.05
                        });
                    },
                    onComplete: function() {
                        _this.$mainvisualPostTitle.addClass('mainvisual-post-title-animation');
                        _this.$mainvisualPostLead.addClass('mainvisual-post-lead-animation');
                    }
                });

            });
        });
        this.mainvisualBgImg = $('.mainvisual-bg-img');
    }
};

module.exports = mvItemsHover;



/** WEBPACK FOOTER **
 ** ./src/pc/assets/js/module/MvItemsHover.js
 **/